<template>
    <div class="environmental">
        <Title firstName="效益估算" lastName="ECONOMIC BENEFIT" />
        <div class="content">
            <div class="environment" v-show="isShow">
                <div class="con">
                    <div class="cleft">
                        <div class="cimg">
                            <img src="../../assets/img/iconmei.png" alt="">
                        </div>
                    </div>
                    <div class="cright">
                        <div class="level">
                            <p>节约标准煤</p>
                            <p>{{saveCoal}}<span> kg</span></p>
                        </div>
                    </div>
                </div>
                <div class="con">
                    <div class="cleft">
                        <div class="cimg">
                            <img src="../../assets/img/iconCo2.png" alt="">
                        </div>
                    </div>
                    <div class="cright">
                        <div class="level">
                            <p>碳减排</p>
                            <p>{{carbon}}<span> kg</span></p>
                        </div>
                    </div>
                </div>
                <div class="con">
                    <div class="cleft">
                        <div class="cimg">
                            <img src="../../assets/img/economic2.png" alt="">
                        </div>
                    </div>
                    <div class="cright">
                        <div class="level">
                            <p>累计节约成本</p>
                            <p>{{(88.94 * 47).toFixed(2)}}<span> ￥</span></p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
import { mapState } from 'vuex'
export default {
    data(){
        return {
            isShow:true,
            isShowList:false,
            power:[],
            loopUrl:'T1/1AA2/SG',
            loops:[]
        }
    },
    watch: {
    },
    components:{
        Title,
    },
    mounted(){
        this.getinverter()
    },
    methods:{
        async getinverter(){
            let data = {
                projectId :this.$store.state.projectId
            }
            let res = await this.$http.getinverter(data)
            // console.log(res);
            this.loops = res.data.data.loops
        }
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'}),
        allPower(){
            let sum = 0
            this.loops.forEach(item =>{
                sum += isNaN(Number(this.mqtt[item.subLoopUrl +'/Monthly_Power_Generation']).toFixed(2))? 0 :Number(this.mqtt[item.subLoopUrl +'/Monthly_Power_Generation'])
            })
            return sum.toFixed(2)
        },   
        carbon(){
            let sum = 0
            // this.power.forEach((item,index) =>{
            //     item = (item * 0.7244)
            //     sum += Number(item)
            // })
            sum = this.allPower == '--'?'--':Number(this.allPower * 0.7244)
            return sum.toFixed(2)
        },
        saveCoal(){
            let sum = 0
            // this.power.forEach((item,index) =>{
            //     item = (item * 0.12303)
            //     sum += Number(item)
            // })
            sum = this.allPower == '--'?'--':Number(this.allPower * 0.12303)
            return sum.toFixed(2)
        },
        weather(){
            return this.$store.state.Cang.weather
        }
    },
    // watch:{
    //     '$store.state.Cang.weather'(weather){
    //         console.log(weather);
    //         if(weather.indexOf('阴') != -1 || weather.indexOf('云') != -1 || weather.indexOf('雨') != -1){
    //             this.$nextTick(()=>{
    //                 let seriesData = [0, 0, 0, 0, 0, 0, 10, 80, 120, 200, 280, 330, 370, 430, 438, 430, 380, 300, 200, 10, 0, 0, 0, 0, 0 ]
    //                 let time = new Date()
    //                 let hour = time.getHours() + 1
    //                 this.power = seriesData.splice(0,hour)
                    
    //             })
    //         }else{
    //             let seriesData = [0, 0, 0, 0, 0, 0, 10, 160, 240, 400, 560, 660, 720, 860, 864, 860, 640, 600, 400, 10, 0, 0, 0, 0, 0 ]
    //             let time = new Date()
    //             let hour = time.getHours() + 1
    //             this.power = seriesData.splice(0,hour)
    //         }
    //     }
    // }
}
</script>

<style lang="less" scoped>
    .environmental{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 37.8vh;
        right: 1vw;

        .list{
            width: 100%;
            position: absolute;
            top: 5vh;
            left: 0;
            z-index: 99;
        }

        .content{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .environment{
                height: 24vh;
                padding:1.5vh 0 ;
                .con{
                    height: 33%;
                    overflow: hidden;
                    
                    .cleft{
                        float: left;
                        width: 7vw;
                        height: 100%;
                        position: relative;
                        .cimg{
                            width:3vw ;
                            height: 3vw;
                            border: 1px solid rgba(13,148,255,0.45);
                            padding: 4rem;
                            position: absolute;
                            left: 60%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            img{
                                width: 100%;
                                height: 100%;
                                padding: 0.4vh 0.4vh;
                                background-color: rgba(13,148,255,0.45);
                            }
                        }
                    }
                    .cright{
                        float: left;
                        width: 12vw;
                        height: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        text-align: left;

                        .level{
                            padding-left: 1vw;
                            p:nth-child(1){
                                font-weight: 400;
                                color: #E6F3FD;
                                opacity: 0.7;
                                font-size: 14rem;
                                padding-top: 8rem;
                            }
                            p:nth-child(2){
                                padding-top: 5rem;
                                font-size: 28rem;
                                font-family: zcoolqingkehuangyouti;
                                font-weight: 400;
                                color: #00DEFF;
                                span{
                                    font-size: 18rem;
                                }
                            }
                        }
                    }
                    .cright::before{
                        content: '';
                        width: 90%;
                        height: 1rem;
                        background-color: rgba(255, 255, 255, 0.3);
                        position: absolute;
                        left: 0;
                        top: 3.3vh;
                    }
                    .cright::after{
                        content: '';
                        width: 1rem;
                        height: 1rem;
                        border: 1rem solid rgba(255, 255, 255, 0.3);
                        border-radius: 50%;
                        background-color: rgba(255, 255, 255, 0.3);
                        position: absolute;
                        left: -2rem;
                        top:calc(3.3vh - 1rem) ;
                    }
                }
                // .con:nth-child(1){
                //     .cright::after{
                //         content: '';
                //         width: 1rem;
                //         height: 1rem;
                //         border: 1rem solid rgba(255, 255, 255, 0.3);
                //         border-radius: 50%;
                //         background-color: rgba(255, 255, 255, 0.3);
                //         position: absolute;
                //         left: -2rem;
                //         top:calc(3.3vh - 1rem) ;
                //     }
                // }
            }

            
            
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>